import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data";
import { SectionHeading } from "./SectionHeading";

export const Services = ({ onBook }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative z-10 py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="What We Offer"
          title="Detailing services engineered for perfection"
          subtitle="From quick maintenance washes to full ceramic protection — every service is performed with obsessive attention to detail."
        />

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.id}
              data-testid={`service-card-${s.id}`}
              onClick={onBook}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              whileHover={{ y: -8 }}
              className={`gloss-sweep group relative text-left overflow-hidden rounded-2xl border border-white/5 bg-[#111111] hover:border-white/25 transition-colors duration-300 ${s.span} ${
                s.image ? "min-h-[260px] md:min-h-[300px]" : "min-h-[180px]"
              }`}
            >
              {s.image && (
                <>
                  <img
                    src={s.image}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/60 to-transparent" />
                </>
              )}
              <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-heading text-xl md:text-2xl font-semibold tracking-tight text-white">
                    {s.title}
                  </h3>
                  <ArrowUpRight
                    size={22}
                    className="shrink-0 text-zinc-500 group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300"
                  />
                </div>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed max-w-md">
                  {s.desc}
                </p>
                {s.price && (
                  <div className="mt-4 flex items-center gap-3">
                    <span className="rounded-full bg-white/10 border border-white/15 px-3 py-1 font-heading text-sm font-semibold text-white">
                      {s.price}
                    </span>
                    <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-500">
                      {s.duration}
                    </span>
                  </div>
                )}
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
